import { render, staticRenderFns } from "./companyFill.vue?vue&type=template&id=012efe54&scoped=true&"
import script from "./companyFill.vue?vue&type=script&lang=js&"
export * from "./companyFill.vue?vue&type=script&lang=js&"
import style0 from "./companyFill.vue?vue&type=style&index=0&id=012efe54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012efe54",
  null
  
)

export default component.exports